export default __webpack_public_path__ + "static/media/fan_mode_on.42b1c949.png";